import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const BearPutSpreadSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02042 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.28916 6.18963H7.74366L17.4133 18.0225" stroke="#089981" strokeWidth="2"/>
        <path d="M17.4133 18.0225L21.5078 23.2032H30.8324" stroke="#A40C0C" strokeWidth="2"/>
    </svg>

)

const BearPutSpread: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BearPutSpreadSvg(props)}
    </SvgIcon>
));
export default BearPutSpread